module.exports = __webpack_public_path__ + "static/img/099_TO8_1779_og.4fe61cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/099_TO8_1779_og.jpg
// module id = +TI6
// module chunks = 0